import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const EmployeSidebar = ({ isOpen, onClose }) => {
  const { user } = useAuth();

  const menuItems = [
    { icon: '🏠', name: 'Dashboard', key: 'dashboard' },
    { icon: '💸', name: 'Retrait Instantané', key: 'retrait' },
    { icon: '📋', name: 'Mes Retraits', key: 'historique' },
    { icon: '👤', name: 'Mon Profil', key: 'profil' },
  ];

  const handleMenuClick = (key) => {
    if (window.employeSetActiveTab) {
      window.employeSetActiveTab(key);
    }
    onClose(); // Fermer le sidebar sur mobile après la sélection
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-40 bg-gray-600 bg-opacity-75 md:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-50 w-64 transform transition-transform duration-300 ease-in-out md:translate-x-0 md:static md:inset-0
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `}
      style={{ background: 'linear-gradient(180deg, #7C3AED 0%, #A855F7 50%, #EC4899 100%)' }}>
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between h-16 px-4 border-b border-white/20">
            <div className="flex items-center space-x-3">
              <img 
                src="/logo-alo-advance.png" 
                alt="ALO ADVANCE" 
                className="h-10 w-auto drop-shadow-lg"
              />
            </div>
            
            <button 
              onClick={onClose}
              className="md:hidden text-white hover:bg-white/10 p-2 rounded"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* User info */}
          <div className="px-4 py-4 border-b border-white/20">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                <span className="text-purple-600 font-bold">
                  {user?.nom?.charAt(0) || 'E'}
                </span>
              </div>
              <div>
                <p className="text-white font-medium text-sm">
                  {user?.nom} {user?.prenom}
                </p>
                <p className="text-purple-100 text-xs">
                  Mat: {user?.matricule}
                </p>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-4 py-4 space-y-2">
            {menuItems.map((item) => (
              <button
                key={item.key}
                onClick={() => handleMenuClick(item.key)}
                className="w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-white hover:bg-white/10 transition-all duration-200"
              >
                <span className="text-lg">{item.icon}</span>
                <span className="font-medium">{item.name}</span>
              </button>
            ))}
          </nav>

          {/* Footer */}
          <div className="px-4 py-4 border-t border-white/20">
            <div className="text-center">
              <p className="text-white text-xs font-medium">
                by ALO FINANCES
              </p>
              <p className="text-purple-100 text-xs">
                Version 1.0
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeSidebar;